import { useMemo } from "react";
import { ChatObject } from "../../../services/api/instances/botApi/types";
import { makeSelectChatsByRef } from "../redux/selectors";
import { useAppSelector } from "../../../services/redux/hooks/use-selector";

export const useChatsByRef = (ref: string | null | undefined): ChatObject[] => {
  const selector = useMemo(() => makeSelectChatsByRef(ref), [ref]);

  return useAppSelector(selector);
};
